import { render, staticRenderFns } from "./ReminderCreationModal.vue?vue&type=template&id=adea47ce&scoped=true"
import script from "./ReminderCreationModal.vue?vue&type=script&lang=js"
export * from "./ReminderCreationModal.vue?vue&type=script&lang=js"
import style0 from "./ReminderCreationModal.vue?vue&type=style&index=0&id=adea47ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adea47ce",
  null
  
)

export default component.exports